module.exports = __webpack_public_path__ + "static/media/Simfoni Optimize - Overview.cfaf5e4d.pdf";